import { Logtail } from '@logtail/browser'
import * as Sentry from '@sentry/react'

const token = import.meta.env.VITE_BETTERSTACK_TOKEN
const host = import.meta.env.VITE_BETTERSTACK_ENDPOINT

const logtail = token && host ? new Logtail(token, { endpoint: host }) : null

// Capture unhandled errors
window.addEventListener('error', (event) => {
  logtail?.error('Unhandled error', event.error || event.message)
  Sentry.captureException(event.error || event.message)
})

window.addEventListener('unhandledrejection', (event) => {
  logtail?.error('Unhandled rejection', event.reason)
  Sentry.captureException(event.reason)
})

export const logger = logtail || console
